import { CalendarRange, Lock } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useSession, switchSession } from "@/lib/useSession";

export const SessionPicker = () => {
  const { current_session: current, rows, active } = useSession();
  if (!rows.length) return null;

  return (
    <Select value={current || active} onValueChange={(v) => v !== current && switchSession(v)}>
      <SelectTrigger data-testid="session-picker" className="rounded-[2px] h-9 w-[150px] text-xs">
        <CalendarRange size={14} className="mr-1 shrink-0" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {rows.map((r) => (
          <SelectItem key={r.name} value={r.name} data-testid={`session-option-${r.name}`}>
            <span className="mono">{r.name}</span>
            {r.active
              ? <span className="ml-2 label-xs text-[#1F7A45]">LIVE</span>
              : r.unlocked
                ? <span className="ml-2 label-xs text-[#B4530A]">OPEN</span>
                : <span className="ml-2 label-xs text-muted-foreground">VIEW</span>}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

/** A thin strip that makes it impossible to miss that this session cannot be written to. */
export const SessionBanner = () => {
  const { current_session: current, active, writable, rows } = useSession();
  if (!rows.length || !current || current === active) return null;
  return (
    <div data-testid="session-banner"
      className={`px-4 sm:px-8 py-2 flex items-center gap-2 text-xs font-semibold border-b ${
        writable ? "bg-[#FFF3E6] text-[#B4530A] border-[#F0C9A0]"
          : "bg-[#F4F5F7] text-muted-foreground border-border"}`}>
      <Lock size={13} />
      {writable
        ? `You are working in session ${current} — entries here are recorded against ${current}, not the live session ${active}.`
        : `Viewing session ${current} (view only). Switch to ${active} or ask an admin to unlock ${current} to make entries.`}
    </div>
  );
};
